<template>
  <div class="profile-input-wrapper">
    <h6 class="title">{{inputTitle}}</h6>
    <span v-html="inputBody"></span>
    <profile-form ref="form" :endpoint="endpoint" @error="$emit('done', $event)">
      <form class="form-hidden">
        <input :name="field" type="hidden" data-field-type="Hidden" checked value="true">
        <input
          v-for="n in needs"
          :key="n"
          :name="n"
          type="hidden"
          checked
          value="true"
          data-field-type="Hidden"
        >
      </form>
    </profile-form>
  </div>
</template>

<script>
import ProfileInputMixin from '@mixins/profile-input-mixin'
export default {
  name: 'profile-accept-input',
  mixins: [ProfileInputMixin],
  props: {
    field: {
      type: String,
      required: true
    },
    inputBody: {
      type: String,
      required: true
    },
    needs: {
      type: Array,
      default: () => []
    },
    endpoint: {
      type: String,
      default: 'sensitivedata'
    }
  },
}
</script>